import React from 'react';

const Massachusetts = () => (
  <svg
    width="46"
    height="26"
    viewBox="0 0 46 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.741 19.4211C39.6776 20.7236 38.9947 21.4066 37.6923 21.47C38.0654 19.9069 36.8123 19.9632 37.1784 18.4001C35.2987 19.4211 34.3201 21.3432 33.081 23.0049C31.2647 22.9486 31.0182 21.308 31.0323 19.4211C30.5536 19.7942 30.2579 20.3505 30.0115 20.956C28.4556 20.1252 27.8291 18.3579 26.942 16.8582C17.3674 17.689 10.6159 21.3503 0.837158 21.9769C1.1258 17.4215 1.42856 15.8373 1.35112 10.7115C7.67316 9.42302 16.8042 7.52902 22.8517 6.10676C24.6751 5.67727 26.8645 3.77622 27.4559 1.50202C28.0543 1.58651 28.3641 1.38937 28.4838 0.988037C30.0185 2.12866 30.3142 5.66319 33.088 4.05786C31.2013 5.41675 30.0397 7.49382 28.9907 9.69057C29.0893 10.106 29.5046 10.1975 29.5046 10.7115C30.3776 12.2464 31.3702 11.2818 33.088 11.2255C33.7639 12.4224 35.6295 12.4436 35.1367 14.8093C37.4741 15.2036 37.3825 18.027 39.741 18.3931"
      fill="#FC374D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.4873 18.907C41.2192 19.2379 44.2676 17.9706 45.6334 16.2596L44.7815 15.5767L43.4157 16.5976L43.2468 17.2806C43.2468 17.2806 41.1981 18.1325 40.5152 17.7945C39.8323 17.4495 39.7478 18.393 39.7478 18.393L39.4873 18.907Z"
      fill="#FC374D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.2271 23.5188C39.3186 24.6383 38.8118 25.1452 37.6924 25.0537C38.2415 24.5749 37.8543 23.1667 39.2271 23.5188Z"
      fill="#FC374D"
    />
  </svg>
);
export default Massachusetts;
